module.exports = __webpack_public_path__ + "img/qiu.f2a87e7a.png";